import { DocumentWithContentAcceptedContentType } from "./valueObjects/DocumentWithContentAcceptedContentType";
import { DocumentWithContentFileExtension } from "./valueObjects/DocumentWithContentFileExtension";

type StorageFileWithContentParams = {
  content: string;
  contentType: DocumentWithContentAcceptedContentType;
  extension: DocumentWithContentFileExtension;
  name: string;
};

export class StorageFileWithContent {
  private readonly content: string;
  private readonly contentType: DocumentWithContentAcceptedContentType;
  private readonly extension: DocumentWithContentFileExtension;
  public readonly name: string;

  constructor({ content, contentType, extension, name }: StorageFileWithContentParams) {
    this.content = content;
    this.contentType = contentType;
    this.extension = extension;
    this.name = name;
  }

  public toPrimitives() {
    return {
      content: this.content,
      contentType: this.contentType.toString(),
      extension: this.extension.toString(),
      name: this.name,
    };
  }

  public getName() {
    return this.name;
  }

  public getContentType() {
    return this.contentType.getValue();
  }

  public getContent() {
    return this.content;
  }

  public getExtension() {
    return this.extension.getValue();
  }
}
